import React from 'react';

class SMOExtraBusinessHourView extends React.Component {

  constructor(props) {
    super(props);

    this.isChange = false;

    this.state = {
      toggle: this.props.toggle,
      businessStartHour: this.props.initialBusinessStartHour,
      businessEndHour: this.props.initialBusinessEndHour,
    };
  }

  getKey() {
    return 'extra_business_hours_' + this.props.weekday;
  }

  didBlur(name, e) {
    if (this.isChange) {
      $(document).trigger("SMRoomHandleUpdateExtraBusinessHours", [{weekday: this.props.weekday, name: name, value: e.currentTarget.value}]);
    }
    this.isChange = false;
  }

  didChangeValue(name, e) {
    if (e.currentTarget.type == 'radio') {
      if (e.currentTarget.value == 1) {
        this.setState({ toggle: true });
      } else {
        this.setState({ toggle: false, businessStartHour: '', businessEndHour: '' });
      }
      $(document).trigger("SMRoomHandleUpdateExtraBusinessHours", [{weekday: this.props.weekday, name: 'toggle', value: e.currentTarget.value}]);
    } else if (e.currentTarget.type == 'text') {
      this.isChange = true;
      if (name == 'start_hour') {
        this.setState({businessStartHour: e.currentTarget.value});
      } else {
        this.setState({businessEndHour: e.currentTarget.value});
      }
    }
  }

  render() {
    return(
      <div className="mb10" key={this.props.weekday}>
        <span className="mr30">{I18n.t('date.day_names')[this.props.weekday]}</span>

        <input type="radio" value={0} id={this.getKey()+"_0"} name={this.getKey()+"_toggle"} defaultChecked={!this.state.toggle} onChange={this.didChangeValue.bind(this, 'toggle')} />
        <label htmlFor={this.getKey()+"_0"} className="form-radio">変更なし</label>

        <input type="radio" value={1} id={this.getKey()+"_1"} name={this.getKey()+"_toggle"} defaultChecked={this.state.toggle} onChange={this.didChangeValue.bind(this, 'toggle')} />
        <label htmlFor={this.getKey()+"_1"} className="form-radio">変更あり</label>

        <input type="text" className="form-text w40" placeholder="9" disabled={!this.state.toggle} name={this.getKey()+"_start"} value={this.state.businessStartHour} onChange={this.didChangeValue.bind(this, 'start_hour')} onBlur={this.didBlur.bind(this, 'start_hour')} />  :00〜
        <input type="text" className="form-text w40" placeholder="20" disabled={!this.state.toggle} name={this.getKey()+"_end"} value={this.state.businessEndHour} onChange={this.didChangeValue.bind(this, 'end_hour')} onBlur={this.didBlur.bind(this, 'end_hour')} />  :00
      </div>
    );
  }
}

SMOExtraBusinessHourView.defaultProps = {
  toggle: false,
};

export default SMOExtraBusinessHourView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMOExtraBusinessHourView.jsx